import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback, useEffect, useMemo } from 'react';
import { validateEmail, validatePhone } from "../../../utils/validators";
export var useForm = function useForm(items, onSubmitForm, isSuccessSending) {
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    errors = _React$useState2[0],
    setErrors = _React$useState2[1];
  var _React$useState3 = React.useState({}),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    formState = _React$useState4[0],
    setFormState = _React$useState4[1];
  var onChange = useCallback(function (key, value) {
    setFormState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty({}, key, value));
    });
  }, []);
  var handleSubmit = useCallback(function () {
    var newErrors = [];
    items.forEach(function (item) {
      if (item.required && !formState[item.key]) {
        newErrors.push(item.key);
      }
      if (item.required && item.type === 'email' && !validateEmail(formState[item.key])) {
        newErrors.push(item.key);
      }
      if (item.required && item.type === 'phone' && !validatePhone(formState[item.key])) {
        newErrors.push(item.key);
      }
    });
    if (newErrors.length) {
      setErrors(newErrors);
      return;
    }
    setErrors([]);
    var formData = items.map(function (item) {
      return {
        key: item.key,
        value: formState[item.key]
      };
    });
    onSubmitForm === null || onSubmitForm === void 0 ? void 0 : onSubmitForm(formData);
  }, [items, formState, onSubmitForm]);

  // очищаем форму при успешной отправке,
  // FileUploader очищается отдельно
  useEffect(function () {
    if (isSuccessSending) {
      setFormState(function (prev) {
        return Object.keys(prev).reduce(function (acc, key) {
          acc[key] = '';
          return acc;
        }, {});
      });
    }
  }, [isSuccessSending]);
  return useMemo(function () {
    return {
      handleSubmit: handleSubmit,
      onChange: onChange,
      formState: formState,
      errors: errors
    };
  }, [handleSubmit, onChange, formState, errors]);
};